import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Provider } from 'react-redux'

import store from './redux/store'

import ServiceWorkerApp from './service-worker'
import Offline from './pages/Offline'

import Auth from './pages/Auth'
import AuthLoginRegisterContent from './components/Auth/LoginRegister'
import AuthOtp from './components/Auth/Otp'

import Layout from './components/Layouts/User'
import Home from './pages/User/Home'
import Profile from './pages/User/Profile'

import AdminLayout from './components/Layouts/Admin'
import AdminDashboard from './pages/Admin/Dashboard'
import ScrollToTop from './components/Helper/ScrollToTop'
import AdminUsers from './pages/Admin/Users'
import AdminProfile from './pages/Admin/Profile'
import UserSupport from './pages/User/Support'
import AdminStaff from './pages/Admin/Staff'
import AdminServices from './pages/Admin/Services'
import AdminHolidays from './pages/Admin/Holidays'
import AdminMenuMobile from './pages/Admin/MenuMobile'
import AdminAppointments from './pages/Admin/Appointments'
import AdminPayments from './pages/Admin/Payments'
import AddAppointment from './pages/User/AddAppointment'
import PaymentResult from './pages/PaymentResult'

const App = () => {

    return (
        <Provider store={store}>

            {/* <ServiceWorkerApp /> */}
        
            <Router>

                <ScrollToTop />

                <Routes>

                    <Route path='/offline' element={<Offline />} />

                    <Route path='/auth' element={ <Auth /> } >

                        <Route path='' element={ <AuthLoginRegisterContent /> } />
                        <Route path='otp' element={ <AuthOtp /> } />

                    </Route>

                    <Route path="/admin" element={<AdminLayout />}>
                        
                        <Route path='' element={<AdminDashboard />} />
                        <Route path='/admin/users' element={<AdminUsers />} />
                        <Route path='/admin/profile' element={<AdminProfile />} />
                        <Route path='/admin/staff' element={<AdminStaff />} />
                        <Route path='/admin/services' element={<AdminServices />} />
                        <Route path='/admin/holidays' element={<AdminHolidays />} />
                        <Route path='/admin/menus' element={<AdminMenuMobile />} />
                        <Route path='/admin/appointments' element={<AdminAppointments />} />
                        <Route path='/admin/payments' element={<AdminPayments />} />
                        
                    </Route>

                    <Route path='' element={ <Layout /> }>

                        <Route path='' element={ <Home /> } />
                        <Route path='/profile' element={ <Profile /> } />
                        <Route path='/support' element={ <UserSupport /> } />
                        <Route path='/reserve' element={ <AddAppointment /> } />

                    </Route>
                    
                    <Route path='/payment-result' element={ <PaymentResult /> } />

                </Routes>
                
            </Router>
            
        </Provider>
    )

}

export default App